export const LAB_RESULTS_RETRIEVE_REQUESTED = 'LAB_RESULTS_RETRIEVE_REQUESTED';
export const LAB_RESULTS_RETRIEVE_SUCCEED = 'LAB_RESULTS_RETRIEVE_SUCCEED';
export const LAB_RESULTS_RETRIEVE_FAILED = 'LAB_RESULTS_RETRIEVE_FAILED';

export const LAB_RESULTS_DETAILS_RETRIEVE_REQUESTED = 'LAB_RESULTS_DETAILS_RETRIEVE_REQUESTED';
export const LAB_RESULTS_DETAILS_RETRIEVE_SUCCEED = 'LAB_RESULTS_DETAILS_RETRIEVE_SUCCEED';
export const LAB_RESULTS_DETAILS_RETRIEVE_FAILED = 'LAB_RESULTS_DETAILS_RETRIEVE_FAILED';

export const LAB_RESULTS_UPDATE_REQUESTED = 'LAB_RESULTS_UPDATE_REQUESTED';
export const LAB_RESULTS_UPDATE_SUCCEED = 'LAB_RESULTS_UPDATE_SUCCEED';
export const LAB_RESULTS_UPDATE_FAILED = 'LAB_RESULTS_UPDATE_FAILED';

export const LAB_RESULTS_SEND_TO_PATIENT_REQUESTED = 'LAB_RESULTS_SEND_TO_PATIENT_REQUESTED';
export const LAB_RESULTS_SEND_TO_PATIENT_SUCCEED = 'LAB_RESULTS_SEND_TO_PATIENT_SUCCEED';
export const LAB_RESULTS_SEND_TO_PATIENT_FAILED = 'LAB_RESULTS_SEND_TO_PATIENT_FAILED';

export const LAB_RESULTS_FILTER_CHANGE_STATUS = 'LAB_RESULTS_FILTER_CHANGE_STATUS';
export const LAB_RESULTS_FILTER_CHANGE_ABNORMAL = 'LAB_RESULTS_FILTER_CHANGE_ABNORMAL';

export const LAB_RESULTS_SEARCH_CHANGE = 'LAB_RESULTS_SEARCH_CHANGE';
export const LAB_RESULTS_PAGE_CHANGE = 'LAB_RESULTS_PAGE_CHANGE';
